// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M9.55 15.15L18.02 6.68Q18.32 6.38 18.72 6.38T19.42 6.68 19.72 7.39 19.42 8.1L10.24 17.3Q9.94 17.6 9.54 17.6T8.84 17.3L4.55 13Q4.25 12.7 4.26 12.29T4.57 11.58 5.28 11.28 5.99 11.58Z"/>';

/** Checkmark (actions). */
const icon: IconData = {
  id: "check",
  name: "Checkmark",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M9.55 18L3.85 12.3 5.28 10.87 9.55 15.15 18.73 5.97 20.15 7.4Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M9.55 15.15L18.02 6.68Q18.32 6.38 18.72 6.38T19.42 6.68 19.72 7.39 19.42 8.1L10.24 17.3Q9.94 17.6 9.54 17.6T8.84 17.3L4.55 13Q4.25 12.7 4.26 12.29T4.57 11.58 5.28 11.28 5.99 11.58Z"/></g><path d="M9.55 15.15L18.02 6.68Q18.32 6.38 18.72 6.38T19.42 6.68 19.72 7.39 19.42 8.1L10.24 17.3Q9.94 17.6 9.54 17.6T8.84 17.3L4.55 13Q4.25 12.7 4.26 12.29T4.57 11.58 5.28 11.28 5.99 11.58Z"/>',
    },
  },
  animation: () => import("../animations/check.js"),
};

export default icon;
